/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import EditIcon from "@mui/icons-material/Edit";
import {
  ButtonGroup,
  IconButton,
  Paper,
  TableContainer,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { handleEditOpen, rowValue } from "../../../redux/Reducer/ModalSlice";
import AddModal from "../../modal/AddModal";
import EditModal from "../../modal/EditModal";
import TableFilter from "../../table-components/filter/TableFilter";
import Pagination from "../../table-components/pagination/Pagination";
import TableComp from "../../table-components/table/TableComp";
import AddTrials from "./AddTrials.js";
import EditTrials from "./EditTrials.js";
import { useQuery } from "@tanstack/react-query";
import useProfile from "../../../hooks/useProfile.js";
import {
  ActiveStatus,
  InactiveStatus,
  StatusContainer,
} from "../../Dashboard/Dashboard.style.js";

const TrialSetup = () => {
  const dispatch = useDispatch();

  const [userData] = useProfile();
  // console.log(userData);

  function handleEdit(rowData) {
    dispatch(handleEditOpen());
    dispatch(rowValue(rowData));
  }

  const {
    refetch,
    isLoading,
    data: allTrialsDetails = [],
  } = useQuery({
    queryKey: ["allTrialsDetails"],
    queryFn: async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/trial`);
      const data = await res.json();
      // console.log("trial list => ", data.data);
      return data.data;
    },
  });
  // console.log("trial info =>", allTrialsDetails);

  const columns = React.useMemo(
    () => [
      {
        Header: "Trial Name",
        accessor: "trial_name",
        Filter: false,
      },
      {
        Header: "Trial Description",
        accessor: "description",
        Filter: false,
      },
      {
        Header: "Status",
        accessor: "active_flag",
        Cell: ({ value }) => (
          <div
            style={{
              marginLeft: "10Px",
              display: "flex",
              justifyContent: "start",
              alignItem: "center",
            }}
          >
            {value === "1" ? (
              <StatusContainer>
                <ActiveStatus>Active</ActiveStatus>
              </StatusContainer>
            ) : (
              <StatusContainer>
                <InactiveStatus>Inactive</InactiveStatus>
              </StatusContainer>
            )}
          </div>
        ),
        Filter: false,
      },
      {
        Header: "Action",
        accessor: "col5",
        Cell: (row) => (
          <ButtonGroup
            style={{
              marginLeft: "10Px",
            }}
          >
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#2196F3" }}
              variant="none"
              onClick={() => handleEdit(row.row.original)}
            >
              <Tooltip title="Update">
                <EditIcon sx={{ fontSize: 18 }} />
              </Tooltip>
            </IconButton>
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );

  const add = useSelector((state) => state.Modal.add);
  const edit = useSelector((state) => state.Modal.edit);

  useEffect(() => {
    if (!add) {
      refetch();
    }
  }, [add]);

  useEffect(() => {
    if (!edit) {
      refetch();
    }
  }, [edit]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: allTrialsDetails },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );
  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;

  return (
    <>
      <div>
        <TableFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          ButtonName="Add Trial"
        />
      </div>

      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {isLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "280px",
            }}
          >
            <CircularProgress />
          </div>
        )}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>
      <AddModal ModalWidth="sm" ModalTitle="Add Trial Information">
        <AddTrials userData={userData} />
      </AddModal>

      <EditModal ModalWidth="sm" ModalTitle="Edit Trial Information">
        <EditTrials userData={userData} />
      </EditModal>
    </>
  );
};

export default TrialSetup;
